import "../_scss/optimalSimulator.scss";

const SLIDE_DURATION = 300;
const USAGE_ERROR_MESSAGE = '0〜600までの半角数字で入力してください。';

const clearSlideTimer = element => {
	if (element.slideTimer) {
		window.clearTimeout(element.slideTimer);
		element.slideTimer = null;
	}
};

const cleanupSlideStyles = element => {
	clearSlideTimer(element);
	delete element.dataset.slideState;
	element.style.height = '';
	element.style.overflow = '';
	element.style.transition = '';
	element.style.opacity = '';
	element.style.willChange = '';
};

const showWithSlide = element => {
	if (!element) return;
	if (element.classList.contains('js-visible') && element.dataset.slideState !== 'hiding') return;

	clearSlideTimer(element);
	element.dataset.slideState = 'showing';
	const startHeight = element.getBoundingClientRect().height;
	element.classList.add('js-visible');
	const height = element.scrollHeight;

	element.style.overflow = 'hidden';
	element.style.height = `${startHeight}px`;
	element.style.opacity = startHeight > 0 ? '1' : '0';
	element.style.willChange = 'height, opacity';
	element.offsetHeight; // reflow
	element.style.transition = `height ${SLIDE_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), opacity ${SLIDE_DURATION}ms linear`;
	element.style.height = `${height}px`;
	element.style.opacity = '1';

	element.slideTimer = window.setTimeout(() => {
		cleanupSlideStyles(element);
	}, SLIDE_DURATION);
};

const hideWithSlide = element => {
	if (!element || !element.classList.contains('js-visible')) return;

	clearSlideTimer(element);
	element.dataset.slideState = 'hiding';

	element.style.height = `${element.scrollHeight}px`;
	element.style.overflow = 'hidden';
	element.style.opacity = '1';
	element.style.willChange = 'height, opacity';
	element.offsetHeight; // reflow
	element.style.transition = `height ${SLIDE_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), opacity ${SLIDE_DURATION}ms linear`;
	element.style.height = '0px';
	element.style.opacity = '0';

	element.slideTimer = window.setTimeout(() => {
		element.classList.remove('js-visible');
		cleanupSlideStyles(element);
	}, SLIDE_DURATION);
};

const getUsageValidationResult = value => {
	if (value === '') {
		return {
			isFilled: false,
			isValid: false,
		};
	}

	if (!/^\d{1,3}$/.test(value)) {
		return {
			isFilled: true,
			isValid: false,
		};
	}

	const intValue = Number(value);

	return {
		isFilled: true,
		isValid: intValue >= 0 && intValue <= 600,
	};
};

const hideFieldError = field => {
	if (!field) return;

	const errorElement = field.querySelector('.m-gasSimCont__er');
	if (errorElement) {
		errorElement.remove();
	}
};

const showFieldError = field => {
	if (!field) return;

	hideFieldError(field);
	field.insertAdjacentHTML('beforeend', `<div class="m-gasSimCont__er"><p>${USAGE_ERROR_MESSAGE}</p></div>`);
};

const updateUsageFieldError = input => {
	if (!input) {
		return {
			isFilled: false,
			isValid: false,
		};
	}

	const field = input.closest('[data-validate]');
	const value = input.value.trim();
	const validation = getUsageValidationResult(value);

	if (validation.isFilled && !validation.isValid) {
		showFieldError(field);
	} else {
		hideFieldError(field);
	}

	return validation;
};

/**
 * 発火層
 */
document.addEventListener("DOMContentLoaded", () => {
	const step1 = document.querySelector('.m-optimalSim__step[data-step="1"]');
	if (!step1) return;

	const step2 = document.querySelector('.m-optimalSim__step[data-step="2"]');
	const parentRadios = step1.querySelectorAll('.js-plan-parent');
	const childPlanAreas = step1.querySelectorAll('.js-child-plans');
	const simulationForm = document.getElementById('simulation');

	parentRadios.forEach(radio => {
		radio.addEventListener('change', () => {
			const parentId = radio.value;
			const targetChildArea = step1.querySelector(`.js-child-plans[data-parent="${parentId}"]`);

			// 全ての子プランエリアを非表示にし、中にあるラジオボタンのチェックを外す
			childPlanAreas.forEach(area => {
				hideWithSlide(area);
				const areaRadios = area.querySelectorAll('input[type="radio"]');
				areaRadios.forEach(r => r.checked = false);
			});

			if (targetChildArea) {
				// 下層があれば対応するエリアを表示
				showWithSlide(targetChildArea);
				// 下層がある場合は、STEP2以降を一旦隠す（子プランを選択させるため）
				if (step2) hideWithSlide(step2);
			} else {
				// 下層がなければSTEP2を表示
				if (step2) showWithSlide(step2);
				// 他の親プランの隠しラジオボタンを解除（q1_parentとq1が一致するように、q1をセット）
				const q1Input = step1.querySelector(`input[name="q1"][value="${parentId}"][data-parent-only]`);
				if (q1Input) q1Input.checked = true;
			}
		});
	});

	// 初期表示状態の制御（PHP側で既にチェックが入っている場合）
	const checkedParent = step1.querySelector('.js-plan-parent:checked');
	if (checkedParent) {
		const targetChildArea = step1.querySelector(`.js-child-plans[data-parent="${checkedParent.value}"]`);
		if (targetChildArea) {
			targetChildArea.classList.add('js-visible');
		}
	}

	const childRadios = step1.querySelectorAll('.js-plan-child');
	childRadios.forEach(radio => {
		radio.addEventListener('change', () => {
			// 子プランが選択されたらSTEP2を表示
			if (step2) showWithSlide(step2);
			// 親プランの隠しラジオボタン（valueを保持する用）にチェックを入れる
			const parentId = radio.closest('.js-child-plans').dataset.parent;
			const parentInput = step1.querySelector(`input[name="q1_parent"][value="${parentId}"]`);
			if (parentInput) parentInput.checked = true;
		});
	});

	// STEP 2 のラジオボタンに対するイベント (連鎖表示用)
	if (step2) {
		const step2Radios = step2.querySelectorAll('input[type="radio"]');
		const step3 = document.querySelector('.m-optimalSim__step[data-step="3"]');
		const step4 = document.querySelector('.m-optimalSim__step[data-step="4"]');
		const step4_1 = document.querySelector('.m-optimalSim__stepChild[data-step="4-1"]');
		const step4_2 = document.querySelector('.m-optimalSim__stepChild[data-step="4-2"]');
		const step4_1Usage = step4_1 ? step4_1.querySelector('.m-optimalSim__monthUsage') : null;
		const submitArea = document.querySelector('.js-submit');
		const resultArea = document.querySelector('#simulation-result');

		const updateStep4MonthUsage = () => {
			if (!step4_1Usage) return;

			const q2 = document.querySelector('input[name="q2"]:checked');
			const q3 = document.querySelector('input[name="q3"]:checked');

			if (q2 && q2.value === '1' && q3) {
				showWithSlide(step4_1Usage);
			} else {
				hideWithSlide(step4_1Usage);
			}
		};

		const checkComplete = () => {
			if (!submitArea) return;

			// 結果画面（simulation-result）が存在し、かつ表示されている場合は
			// 送信ボタンの制御を行わない（PHP側で送信ボタン自体を出力していないはずだがJSでもガード）
			if (resultArea && resultArea.classList.contains('js-visible')) {
				return;
			}

			const q1 = document.querySelector('input[name="q1"]:checked');
			const q2 = document.querySelector('input[name="q2"]:checked');

			if (!q1 || !q2) {
				hideWithSlide(submitArea);
				return;
			}

			if (q2.value === '1') {
				// 1か月分の場合: q3(使用月)とq4[](使用量)が必要
				const q3 = document.querySelector('input[name="q3"]:checked');
				const q4 = document.querySelector('input[name="q4[]"]');
				const q4Validation = updateUsageFieldError(q4);
				if (q3 && q4Validation.isFilled && q4Validation.isValid) {
					showWithSlide(submitArea);
				} else {
					hideWithSlide(submitArea);
				}
			} else if (q2.value === '2') {
				// 12か月分の場合: q5[](12ヶ月分の使用量)が必要
				const q5Inputs = document.querySelectorAll('input[name="q5[]"]');
				let allFilled = true;
				let allValid = true;
				q5Inputs.forEach(input => {
					const validation = updateUsageFieldError(input);
					if (!validation.isFilled) allFilled = false;
					if (validation.isFilled && !validation.isValid) allValid = false;
				});

				if (allFilled && allValid) {
					showWithSlide(submitArea);
				} else {
					hideWithSlide(submitArea);
				}
			}
		};

		step2Radios.forEach(radio => {
			radio.addEventListener('change', () => {
				if (radio.value === '1') {
					// 1か月分: step3をスキップ
					if (step3) {
						hideWithSlide(step3);
						// 選択をクリア
						const step3Radios = step3.querySelectorAll('input[type="radio"]');
						step3Radios.forEach(r => r.checked = false);
					}
					if (step4) showWithSlide(step4);
					if (step4_1) showWithSlide(step4_1);
					if (step4_1Usage) hideWithSlide(step4_1Usage);
					if (step4_2) {
						hideWithSlide(step4_2);
						// 入力をクリア
						const step4_2Inputs = step4_2.querySelectorAll('input');
						step4_2Inputs.forEach(i => i.value = '');
					}
				} else if (radio.value === '2') {
					// 12か月分: step3をスキップしてstep4を表示
					if (step3) {
						hideWithSlide(step3);
						// 選択をクリア
						const step3Radios = step3.querySelectorAll('input[type="radio"]');
						step3Radios.forEach(r => r.checked = false);
					}
					if (step4) showWithSlide(step4);
					if (step4_1) {
						hideWithSlide(step4_1);
						if (step4_1Usage) hideWithSlide(step4_1Usage);
						// 1ヶ月用の入力をクリア
						const step4_1Radios = step4_1.querySelectorAll('input[type="radio"]');
						step4_1Radios.forEach(r => r.checked = false);
						const step4_1Inputs = step4_1.querySelectorAll('input[type="tel"]');
						step4_1Inputs.forEach(i => i.value = '');
					}
					if (step4_2) showWithSlide(step4_2);
				}
				checkComplete();
			});
		});

		// STEP 3 のラジオボタンに対するイベント
		if (step3) {
			const step3Radios = step3.querySelectorAll('input[type="radio"]');
			step3Radios.forEach(radio => {
				radio.addEventListener('change', () => {
					// STEP 3 が入力されたら STEP 4 を表示
					if (step4) showWithSlide(step4);
					if (step4_1) hideWithSlide(step4_1);
					if (step4_2) showWithSlide(step4_2);
					checkComplete();
				});
			});
		}

		// STEP 4 の入力イベント
		const q3Radios = document.querySelectorAll('input[name="q3"]');
		q3Radios.forEach(radio => {
			radio.addEventListener('change', () => {
				updateStep4MonthUsage();
				checkComplete();
			});
		});

		const q4Input = document.querySelector('input[name="q4[]"]');
		if (q4Input) {
			q4Input.addEventListener('input', checkComplete);
			q4Input.addEventListener('blur', checkComplete);
		}

		const q5Inputs = document.querySelectorAll('input[name="q5[]"]');
		q5Inputs.forEach(input => {
			input.addEventListener('input', checkComplete);
			input.addEventListener('blur', checkComplete);
		});

		const q1Inputs = document.querySelectorAll('input[name="q1"]');
		q1Inputs.forEach(input => {
			input.addEventListener('change', checkComplete);
		});
		const q1ParentInputs = document.querySelectorAll('input[name="q1_parent"]');
		q1ParentInputs.forEach(input => {
			input.addEventListener('change', checkComplete);
		});
		const q2Inputs = document.querySelectorAll('input[name="q2"]');
		q2Inputs.forEach(input => {
			input.addEventListener('change', () => {
				updateStep4MonthUsage();
				checkComplete();
			});
		});
		const q3_2Inputs = document.querySelectorAll('input[name="q3_2"]');
		q3_2Inputs.forEach(input => {
			input.addEventListener('change', checkComplete);
		});

		// エンターキーでのサブミットを禁止
		if (simulationForm) {
			simulationForm.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.keyCode === 13) {
					// button要素やtextarea以外でのエンターは無効化
					if (e.target.tagName !== 'BUTTON' && e.target.tagName !== 'TEXTAREA') {
						e.preventDefault();
						return false;
					}
				}
			});
		}

		// ブラウザバック対応: 結果画面やBFCache復元時は初期状態で再読込
		window.addEventListener('pageshow', (e) => {
			const navigationEntries = window.performance?.getEntriesByType?.('navigation') || [];
			const navigationType = navigationEntries[0]?.type || '';
			const isBackForward = e.persisted || navigationType === 'back_forward';
			const hasResult = Boolean(document.querySelector('.m-optimalSim__result'));
			const currentUrl = new URL(window.location.href);
			const isResetPage = currentUrl.searchParams.get('reset') === '1';

			if (isBackForward && (hasResult || e.persisted) && !isResetPage) {
				// ブラウザバック時はキャッシュ復元を使わず初期状態で再読込
				currentUrl.search = '';
				currentUrl.hash = '';
				currentUrl.searchParams.set('reset', '1');
				window.location.replace(currentUrl.toString());
			}
		});

		// トグルボタンの制御
		const toggleBtn = document.querySelector('.m-optimalSim__toggleBtn');
		const toggleWrapOuter = document.querySelector('.m-optimalSim__toggleWrapOuter');
		const toggleClose = document.querySelector('.m-optimalSim__toggleClose');

		if (toggleBtn && toggleWrapOuter) {
			toggleBtn.addEventListener('click', (e) => {
				// 閉じるボタン自体のクリックや、リンクのクリックは除外したいが、
				// toggleBtnの中にtoggleWrapOuterが入っているので、バブリングを考慮
				if (e.target.closest('.m-optimalSim__toggleClose') || e.target.closest('.m-optimalSim__toggleList')) {
					return;
				}

				const isOpen = toggleBtn.classList.contains('is-open');
				if (isOpen) {
					toggleBtn.classList.remove('is-open');
					toggleWrapOuter.classList.remove('js-visible');
				} else {
					toggleBtn.classList.add('is-open');
					toggleWrapOuter.classList.add('js-visible');
				}
			});
		}

		if (toggleClose && toggleBtn && toggleWrapOuter) {
			toggleClose.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				toggleBtn.classList.remove('is-open');
				toggleWrapOuter.classList.remove('js-visible');
			});
		}

		// 初期状態チェック
		updateStep4MonthUsage();
		checkComplete();
	}
});





